
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/getting-started/custom-components",
      function () {
        return require("private-next-pages/system/getting-started/custom-components.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/getting-started/custom-components"])
      });
    }
  